import { render } from "./Projects.vue?vue&type=template&id=58107d08&scoped=true"
import script from "./Projects.vue?vue&type=script&lang=js"
export * from "./Projects.vue?vue&type=script&lang=js"

import "./Projects.vue?vue&type=style&index=0&id=58107d08&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-58107d08"

export default script